module.exports = __webpack_public_path__ + "img/anticlockwise.ef2191c9.gif";